export const order = {
  orderDetails: {
    orderId: 'Order #',
    orderNumber: 'Order #',
    replenishmentId: 'Replenishment #',
    purchaseOrderId: 'Purchase Order Number',
    purchaseOrderNumber: 'PO #',
    emptyPurchaseOrderId: 'None',
    none: 'None {{value}}',
    placed: 'Placed',
    placedBy: 'Placed By',
    unit: 'Unit',
    costCenter: 'Cost Center',
    costCenterAndUnit: 'Cost Center / Unit',
    costCenterAndUnitValue: '{{costCenterName}} / {{unitName}}',
    methodOfPayment: 'Payment Information',
    payByAccount: 'Pay by Account',
    paidByCreditCard: '(paid by credit card)',
    status: 'Status',
    active: 'Active',
    shippedOn: 'Shipped On',
    shippingMethod: 'Shipping Method',
    placedOn: 'Order Date',
    startOn: 'Start On',
    nextOrderDate: 'Next Order Date',
    frequency: 'Frequency',
    cancelled: 'Cancelled',
    deliveryStatus_IN_TRANSIT: 'In Transit',
    deliveryStatus_READY_FOR_PICKUP: 'Ready for Pickup',
    deliveryStatus_READY_FOR_SHIPPING: 'Ready for Shipping',
    deliveryStatus_WAITING: 'Waiting',
    deliveryStatus_DELIVERING: 'Delivering',
    deliveryStatus_PICKPACK: 'Preparing for Shipment',
    deliveryStatus_PICKUP_COMPLETE: 'Pickup Complete',
    deliveryStatus_DELIVERY_COMPLETED: 'Delivery Completed',
    deliveryStatus_PAYMENT_NOT_CAPTURED: 'Payment Issue',
    deliveryStatus_IN_PROCESS: 'Processing Order',
    deliveryStatus_READY: 'Processing Order',
    deliveryStatus_DELIVERY_REJECTED: 'Delivery Rejected',
    deliveryStatus_SHIPPED: 'Shipped',
    deliveryStatus_TAX_NOT_COMMITTED: 'Tax Issue',
    deliveryStatus_CANCELLED: 'Cancelled',
    statusDisplay_cancelled: 'Cancelled',
    statusDisplay_cancelling: 'Cancellation Pending',
    statusDisplay_completed: 'Completed',
    statusDisplay_created: 'Created',
    statusDisplay_error: 'Pending',
    statusDisplay_Error: 'Pending',
    statusDisplay_processing: 'Pending',
    statusDisplay_open: 'Open',
    statusDisplay_pending: {
      approval: 'Approval Pending',
      merchant: {
        approval: 'Merchant Approval Pending',
      },
    },
    statusDisplay_approved: 'Approved',
    statusDisplay_rejected: 'Rejected',
    statusDisplay_merchant: {
      approved: 'Merchant Approved',
      rejected: 'Merchant Rejected',
    },
    statusDisplay_assigned: {
      admin: 'Assigned to Admin',
    },
    consignmentTracking: {
      action: 'Track Package',
      dialog: {
        header: 'Tracking Information',
        shipped: 'Shipped',
        estimate: 'Estimated Delivery',
        carrier: 'Delivery Service',
        trackingId: 'Tracking Number',
        noTracking:
          'The package has not yet been dispatched from the warehouse. Tracking information will be available after the package is shipped.',
        loadingHeader: 'Consignment Tracking',
      },
    },
    cancellationAndReturn: {
      returnAction: 'Request Return',
      cancelAction: 'Cancel Items',
      item: 'Item',
      itemPrice: 'Item Price',
      quantity: 'Maximum Quantity',
      returnQty: 'Quantity to Return',
      cancelQty: 'Quantity to Cancel',
      setAll: 'Set all quantities to maximum',
      totalPrice: 'Total',
      submit: 'Submit Request',
      submitDescription: 'Submit Request. The items on this page will be included in the cancellation request.',
      returnSuccess: 'Your return request ({{rma}}) has been submitted',
      cancelSuccess: 'Your cancellation request has been submitted (original order {{orderCode}} will be updated)',
    },
    cancelReplenishment: {
      title: 'Cancel Replenishment',
      description: 'Cancel any future replenishment order?',
      accept: 'Yes',
      reject: 'No',
      cancelSuccess: 'Replenishment order #{{replenishmentOrderCode}} has been successfully cancelled',
    },
    caption: 'Order Contents.',
  },
  orderHistory: {
    back: 'Back to Order History',
    orderHistory: 'Order History',
    orderId: 'Order #',
    emptyPurchaseOrderId: 'None',
    date: 'Date',
    status: 'Status',
    PONumber: 'P.O. Number',
    total: 'Total',
    noOrders: 'We have no order records for this account.',
    noReplenishmentOrders: 'We have no replenishment order records for this account.',
    startShopping: 'Start Shopping',
    sortBy: 'Sort By',
    sortOrders: 'Sort Orders',
    replenishmentOrderHistory: 'Replenishment Order History',
    replenishmentOrderId: 'Replenishment #',
    purchaseOrderNumber: 'Purchase Order Number',
    costCenter: 'Cost Center',
    startOn: 'Start On',
    frequency: 'Frequency',
    nextOrderDate: 'Next Order Date',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    replenishmentHistory: 'Replenishment History',
    notFound: 'No Orders Found',
    noOrdersAvailable: 'No orders available.',
    actions: 'Actions',
    table: {
      header: {
        order: 'Order#',
        date: 'Date',
        status: 'Status',
        PO: 'PO#',
        quantity: 'Quantity',
        total: 'Total',
      },
    },
    form: {
      instructions: 'Use the fields below to search for orders.',
      orderDate: 'Order Date',
      showOnlyOpenOrders: 'Show only open orders',
    },
  },
  AccountOrderHistoryTabContainer: {
    tabs: {
      AccountOrderHistoryComponent: 'ALL ORDERS ({{param}})',
      OrderReturnRequestListComponent: 'RETURNS ({{param}})',
    },
    tabPanelContainerRegion: 'Grouping with order history details',
  },
  returnRequestList: {
    returnRequestId: 'Return #',
    orderId: 'Order #',
    date: 'Creation Date',
    status: 'Status',
    sortBy: 'Sort By',
    sortReturns: 'Sort Returns',
    statusDisplay_APPROVAL_PENDING: 'Approval Pending',
    statusDisplay_CANCELED: 'Cancelled',
    statusDisplay_CANCELLING: 'Cancelling',
    statusDisplay_WAIT: 'Waiting',
    statusDisplay_RECEIVED: 'Received',
    statusDisplay_RECEIVING: 'Receiving',
    statusDisplay_APPROVING: 'Approving',
    statusDisplay_REVERSING_PAYMENT: 'Reversing Payment',
    statusDisplay_PAYMENT_REVERSED: 'Payment Reversed',
    statusDisplay_PAYMENT_REVERSAL_FAILED: 'Payment Reversal Failed',
    statusDisplay_REVERSING_TAX: 'Reversing Tax',
    statusDisplay_TAX_REVERSED: 'Tax Reversed',
    statusDisplay_TAX_REVERSAL_FAILED: 'Tax Reversal Failed',
    statusDisplay_COMPLETED: 'Completed',
  },
  returnRequest: {
    returnRequestId: 'Return Request #',
    orderCode: 'For Order #',
    status: 'Return Status',
    cancel: 'Cancel Return Request',
    item: 'Description',
    itemPrice: 'Item Price',
    returnQty: 'Quantity to Return',
    total: 'Total',
    summary: 'Return Totals',
    subtotal: 'Subtotal',
    deliveryCode: 'Delivery Cost',
    estimatedRefund: 'Estimated Refund',
    note: 'Totals are estimated and may not include applicable taxes or other fees.',
    cancelSuccess: 'Your return request ({{rma}}) has been cancelled',
    caption: 'Order Contents.',
  },
  reorder: {
    button: 'Reorder',
    dialog: {
      reorderProducts: 'Reorder Products',
      messages: {
        reviewConfiguration: 'There was an error with the configuration of "{{ productCode }}".',
        lowStock: 'Quantity for {{ productName }}: {{ quantity }} has been reduced to {{ addedQuantity }}.',
        noStock: '{{ productName }} is currently out of stock.',
        pricingError: 'Pricing issue with "{{ productCode }}".',
        unresolvableIssues: 'Unrecognized issue with "{{ productCode }}".',
        success: 'The products have been successfully added to the cart',
      },
      areYouSureToReplaceCart: 'The current cart will be replaced with new items. Do you want to continue?',
      cancel: 'Cancel',
      close_modal_1: 'Cancel creating cart from order',
      close_modal_2: 'Close reorder result dialog',
      close_modal_3: 'Escape clicked',
      continue: 'Continue',
    },
  },
};
